// src/components/BackToTop.tsx
import { useState, useEffect } from 'react'

export default function BackToTop() {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const handler = () => setVisible(window.scrollY > 400)
    window.addEventListener('scroll', handler, { passive: true })
    return () => window.removeEventListener('scroll', handler)
  }, [])

  return (
    <button
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      aria-label="Back to top"
      style={{
        position: 'fixed', bottom: 28, right: 28, zIndex: 999,
        width: 44, height: 44, borderRadius: '50%',
        background: 'linear-gradient(135deg, var(--blue), var(--green-dark))',
        border: 'none', cursor: 'pointer', color: '#fff', fontSize: 18,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        opacity: visible ? 1 : 0,
        transform: visible ? 'translateY(0)' : 'translateY(20px)',
        transition: 'opacity 0.3s, transform 0.3s',
        pointerEvents: visible ? 'all' : 'none',
        boxShadow: '0 4px 16px rgba(26,127,193,0.4)',
      }}
    >
      ↑
    </button>
  )
}
